import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../api";
import type { MarkSanitisedRequest } from "../types";
import { invalidateEvalStewardQueries } from "../utils/invalidateEvalStewardQueries";

export interface MarkAnnotationSanitisedVariables {
  workspaceId: string;
  annotationId: string;
  threadId: string;
  assistantMessageIndex: number;
  body: MarkSanitisedRequest;
}

export function useMarkAnnotationSanitised() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      workspaceId,
      annotationId,
      body,
    }: MarkAnnotationSanitisedVariables) =>
      api.markEvalAnnotationSanitised(workspaceId, annotationId, body),
    onSuccess: (_annotation, variables) => {
      invalidateEvalStewardQueries(
        queryClient,
        {
          workspaceId: variables.workspaceId,
          threadId: variables.threadId,
          assistantMessageIndex: variables.assistantMessageIndex,
        },
        variables.annotationId,
      );
    },
  });
}
